/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Assistant_Saved_Prompt_RemovedInputs */



/**
* | output |
* | --- |
* | "Saved prompt removed" |
*
* @param {Assistant_Saved_Prompt_RemovedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const assistant_saved_prompt_removed = /** @type {((inputs?: Assistant_Saved_Prompt_RemovedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Assistant_Saved_Prompt_RemovedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Invite enregistrée supprimée")
	if (locale === "de") return /** @type {LocalizedString} */ ("Gespeicherte Eingabeaufforderung entfernt")
	if (locale === "it") return /** @type {LocalizedString} */ ("Prompt salvato rimosso")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Сохранённый запрос удалён")
	if (locale === "es") return /** @type {LocalizedString} */ ("Solicitud guardada eliminada")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("已删除保存的提示")
	if (locale === "ja") return /** @type {LocalizedString} */ ("保存したプロンプトを削除しました")
	if (locale === "hi") return /** @type {LocalizedString} */ ("सहेजा गया प्रॉम्प्ट हटाया गया")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Prompt guardado removido")
	return /** @type {LocalizedString} */ ("Saved prompt removed")
});